import { useQuery } from "@tanstack/react-query";

import { ConsentDocumentsApi } from "@/data/api/consentDocumentsApi";

export const ConsentDocumentsQueryKeys = {
  all: ["consentDocument"] as const,
  details: () => [...ConsentDocumentsQueryKeys.all, "details"] as const,
  signed: () => [...ConsentDocumentsQueryKeys.all, "signed"] as const,
};

export const useListConsentDocumentsQuery = () => {
  return useQuery({
    queryKey: ConsentDocumentsQueryKeys.details(),
    queryFn: () => ConsentDocumentsApi.listConsentDocuments(),
  });
};

export const useGetSignedConsentDocumentsQuery = ({ isEnabled = false }) => {
  return useQuery({
    queryKey: ConsentDocumentsQueryKeys.signed(),
    queryFn: () => ConsentDocumentsApi.getSignedConsentDocuments(),
    enabled: isEnabled,
  });
};
